import React from 'react';
import {
  QuizInputBaseProps,
  quizInputContainerStyles,
  quizLabelStyles,
  quizRequiredIndicatorStyles,
  getQuizInputClassName,
} from './QuizInputStyles';

interface Props extends QuizInputBaseProps {
  description?: string;
  onChange: React.ChangeEventHandler<HTMLInputElement> | undefined;
  disabled?: boolean;
}

export default function QuizInputText({
  id,
  label,
  isRequired,
  placeholderText,
  value,
  onChange,
  isLoading = false,
  disabled = false,
  description,
}: Props) {
  const isDisabled = disabled || isLoading;
  return (
    <div className={quizInputContainerStyles}>
      {label && (
        <label htmlFor={id} className={quizLabelStyles}>
          {label}
          {isRequired && <span className={quizRequiredIndicatorStyles}>*</span>}
        </label>
      )}
      {description && <p className='text-sm text-text_gray_900 mt-1'>{description}</p>}
      <div className='w-full flex flex-col relative'>
        <input
          type='text'
          id={id}
          placeholder={placeholderText ?? ''}
          value={value}
          onChange={onChange}
          // Render as readOnly to avoid disabled grey styling, but still be non-interactive
          readOnly={isDisabled}
          aria-disabled={isDisabled}
          tabIndex={isDisabled ? -1 : 0}
          className={`${getQuizInputClassName('text')} ${
            isDisabled ? 'cursor-default pointer-events-none select-none' : ''
          }`}
        />
      </div>
    </div>
  );
}
